import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { sendSupportRequest } from '../features/auth/api';
import { getApiErrorMessage } from '../lib/errors';

export function SupportPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle');
  const [error, setError] = useState('');

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await sendSupportRequest({ name, email, message, website });
      setStatus('sent');
      setMessage('');
    } catch (requestError) {
      setStatus('idle');
      setError(getApiErrorMessage(requestError, 'No pudimos enviar tu mensaje. Inténtalo de nuevo.'));
    }
  }

  return (
    <main className="min-h-full bg-[#faf8f5] px-4 py-8 pb-[calc(2.5rem+env(safe-area-inset-bottom,0px))] pt-safe sm:px-8 sm:py-12">
      <section className="mx-auto max-w-xl rounded-2xl border border-[#e8e2d9] bg-white p-6 shadow-[0_18px_40px_-32px_rgba(15,23,42,.4)] sm:p-8">
        <Link to="/" className="inline-flex min-h-11 items-center text-sm font-semibold text-slate-700 underline">← Volver al inicio</Link>
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900">Soporte</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">Cuéntanos qué ocurrió. No incluyas contraseñas, NIP, CVV, tokens ni números completos de tarjetas o cuentas.</p>

        {status === 'sent' ? (
          <div className="mt-7 rounded-xl bg-green-50 p-4 text-sm leading-6 text-green-800" role="status">
            Recibimos tu mensaje. Te responderemos al correo que indicaste.
          </div>
        ) : (
          <form className="mt-7 space-y-4" onSubmit={onSubmit}>
            <Field id="support-name" label="Nombre" value={name} onChange={setName} autoComplete="name" />
            <Field id="support-email" label="Correo" value={email} onChange={setEmail} type="email" autoComplete="email" />
            <div>
              <label htmlFor="support-message" className="mb-1 block text-sm font-medium text-slate-700">¿Cómo podemos ayudarte?</label>
              <textarea id="support-message" value={message} onChange={(event) => setMessage(event.target.value)} minLength={10} maxLength={3000} required rows={6} className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base" />
            </div>
            <div className="hidden" aria-hidden="true">
              <label htmlFor="support-website">Sitio web</label>
              <input id="support-website" value={website} onChange={(event) => setWebsite(event.target.value)} tabIndex={-1} autoComplete="off" />
            </div>
            {error && <p className="text-sm text-expense" role="alert">{error}</p>}
            <button type="submit" disabled={status === 'sending'} className="button button-primary min-h-12 w-full rounded-xl text-base">
              {status === 'sending' ? 'Enviando…' : 'Enviar mensaje'}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}

function Field({
  id,
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  autoComplete: string;
}) {
  return <div><label htmlFor={id} className="mb-1 block text-sm font-medium text-slate-700">{label}</label><input id={id} type={type} value={value} onChange={(event) => onChange(event.target.value)} autoComplete={autoComplete} required maxLength={type === 'text' ? 80 : undefined} className="tap-target w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base" /></div>;
}
